/* eslint-disable import/prefer-default-export */
export const getBreadcrumbs = (goal) => {
  if (!goal) return [];
  return [
    {
      title: goal?.name,
      href: `/goal/${goal?.slug}/${goal?.uid}`
    },
    {
      title: 'Learn with playlists',
      href: `/goal/${goal?.slug}/${goal?.uid}/playlist`
    }
  ];
};

export const getAuthorCuratedPlaylistUrl = (authorUID) =>
  `v1/curated_content/${authorUID}/playlist?limit=12`;

export const getGoalCuratedPlaylistUrl = (goalUID) =>
  `v1/curated_content/${goalUID}/goal-playlist?limit=12`;
